export const BOOTH_PATH_NAME = 'booth';
